module.exports = __webpack_public_path__ + "img/swipper-default-img.0bbb42cb.png";